import {
  ClientEventHandler,
  ClientSubscriptionParams,
  ClientsService,
  IMessagesFromServer,
  IMessagesToClient,
  IMessagesToServer,
  SocketService,
} from "services";
import { SubscriptionStorage } from "utils";

export abstract class EventHandlingStrategy {
  protected readonly subscriptionsStorage: SubscriptionStorage = new SubscriptionStorage();

  constructor(
    protected readonly clientsService: ClientsService,
    protected readonly socketService: SocketService,
  ) {}

  on<T extends IMessagesToClient>(
    event: T,
    handler: ClientEventHandler<T>,
    params?: ClientSubscriptionParams<T>,
  ): string {
    let rid = this.subscriptionsStorage.findRidByEvent(event, params as any);
    if (rid) {
      this.subscriptionsStorage.addHandlerToSubscription(rid, handler);
    } else {
      rid = this.subscriptionsStorage.createSubscription({ eventName: event, data: params as any, handler });
      this.socketService.startSubscription(rid, event as IMessagesToServer["event"], params as any);
    }
    this.clientsService.subscribe<T>(rid, handler);
    return rid;
  }

  off<T extends IMessagesToClient>(event: T, handler: ClientEventHandler<T>): string | undefined {
    const rid = this.subscriptionsStorage.findRidByHandler(handler);
    if (!rid) {
      return;
    }
    this.clientsService.unsubscribe(rid, handler);
    this.subscriptionsStorage.removeHandlerFromSubscription(rid, handler);
    if (!this.subscriptionsStorage.isSubscriptionExist(rid)) {
      this.socketService.endSubscription(rid);
    }
    return rid;
  }

  public abstract handleServerMessage(message: IMessagesFromServer): void;
}
